import { useLang } from "../i18n";

export function Marquee() {
  const { t } = useLang();
  const names = t.minerals.items.map((m) => m.name);
  const row = [...names, ...names];
  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-[#C9A227]/12 bg-[#151B24]/50 py-5">
      <div className="marquee-track flex w-max items-center gap-10 whitespace-nowrap">
        {row.map((n, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-display text-sm md:text-base tracking-[0.3em] uppercase text-[#EDF1F6]/80">{n}</span>
            <span className="text-[#C9A227] text-xs">◆</span>
          </span>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#07111F] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#07111F] to-transparent" />
    </div>
  );
}
